












import Vue from 'vue';
import {Component,Prop,Watch} from 'vue-property-decorator';
@Component
  export default class FromItem extends Vue {
    @Prop({default: ''}) readonly value!: string;

    @Prop({required: true}) fieldName!: string;
    @Prop() placeholder?: string;

    onValueChanged(value:string){
      this.$emit('update:value',value);
    }
  }
